import { render, staticRenderFns } from "./OrderTransaction.vue?vue&type=template&id=6cf89dfb&scoped=true&"
import script from "./OrderTransaction.vue?vue&type=script&lang=js&"
export * from "./OrderTransaction.vue?vue&type=script&lang=js&"
import style0 from "./OrderTransaction.vue?vue&type=style&index=0&id=6cf89dfb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf89dfb",
  null
  
)

export default component.exports